import { Box, Card, Flex } from "components/styles";
import { ActivityIndicator } from "react-native";
import { FormattedMessage, FormattedNumber } from "react-intl";
import environment from "setup/environment";
import ButtonLink from "components/atoms/ButtonLink";
import { SCREENS } from "navigation/consts";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";

import { useOrderStatus } from "./hooks";
import * as Styled from "./styles";

const OrderDetails: React.FC = () => {
  const { order, loading, polling, error, refetch } = useOrderStatus();

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%" overflow="auto">
      <Card>
        <Styled.Heading>{order?.orderNumber}</Styled.Heading>
        <Styled.Total>
          <FormattedNumber
            style="currency"
            currency={environment.CURRENCY}
            value={order?.totalAmount || 0}
          />
        </Styled.Total>
        <Styled.Subheading>{order?.status}</Styled.Subheading>
        {(loading || polling) && (
          <Box mt="1rem">
            <ActivityIndicator />
          </Box>
        )}
      </Card>
      <Styled.Actions>
        {error && !loading && (
          <>
            <Styled.Error>{error}</Styled.Error>
            <Button
              $fullW
              type="button"
              $mode="primary"
              size="large"
              onClick={refetch}
            >
              <FormattedMessage defaultMessage="Retry" />
            </Button>
          </>
        )}
        <ButtonLink
          to={{ screen: SCREENS.EventDetails }}
          $fullW
          type="button"
          $mode="tertiary"
          size="large"
          disabled={polling}
        >
          <FormattedMessage defaultMessage="Continue" />
        </ButtonLink>
      </Styled.Actions>
    </Flex>
  );
};

export default OrderDetails;
